import { Link } from "react-router-dom";
import styles from "./Home.module.css";

function ExpertiseIcon() {
  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="4"
        y="28"
        width="8"
        height="16"
        rx="1"
        stroke="#4caf50"
        strokeWidth="2.5"
      />
      <rect
        x="16"
        y="20"
        width="8"
        height="24"
        rx="1"
        stroke="#4caf50"
        strokeWidth="2.5"
      />
      <rect
        x="28"
        y="12"
        width="8"
        height="32"
        rx="1"
        stroke="#4caf50"
        strokeWidth="2.5"
      />
      <path
        d="M6 20 L18 12 L30 16 L40 6"
        stroke="#4caf50"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="40" cy="6" r="3" fill="#4caf50" />
      <path
        d="M8 42 Q12 38 16 40"
        stroke="#4caf50"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

function ProjectsIcon() {
  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="4"
        y="8"
        width="40"
        height="32"
        rx="3"
        stroke="#4caf50"
        strokeWidth="2.5"
      />
      <line x1="4" y1="16" x2="44" y2="16" stroke="#4caf50" strokeWidth="2.5" />
      <line x1="4" y1="40" x2="44" y2="40" stroke="#4caf50" strokeWidth="2.5" />
      <line
        x1="24"
        y1="40"
        x2="24"
        y2="44"
        stroke="#4caf50"
        strokeWidth="2.5"
      />
      <line
        x1="16"
        y1="44"
        x2="32"
        y2="44"
        stroke="#4caf50"
        strokeWidth="2.5"
      />
      <path
        d="M16 26 L20 30 L16 34"
        stroke="#4caf50"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="22"
        y1="34"
        x2="30"
        y2="34"
        stroke="#4caf50"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

function WhyUsIcon() {
  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="22" r="16" stroke="#4caf50" strokeWidth="2.5" />
      <path
        d="M24 14 L24 30"
        stroke="#4caf50"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M18 18 Q18 14 24 14 Q30 14 30 19 Q30 24 24 24 Q30 24 30 28 Q30 32 24 32 Q18 32 18 28"
        stroke="#4caf50"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M16 38 Q20 34 24 36 Q28 38 32 34"
        stroke="#4caf50"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

const cards = [
  {
    title: "Our Expertise",
    icon: <ExpertiseIcon />,
    body: "Build fast, scalable, and modern web applications tailored to your business needs using the power of ReactJS and NodeJS. We develop responsive, high-performance websites and custom web applications with clean user interfaces, secure backend systems, and seamless user experiences.",
    btnLabel: "Learn More",
    to: "/services",
  },
  {
    title: "Projects",
    icon: <ProjectsIcon />,
    body: "Custom Web Application Development",
    btnLabel: "Portfolios",
    to: "/portfolio",
  },
  {
    title: "Why Choose Us",
    icon: <WhyUsIcon />,
    body: "We focus on creating secure, scalable, and user-friendly applications that help businesses grow online. Whether you need a startup MVP, business website, SaaS platform, or custom enterprise solution, we deliver reliable solutions with modern technologies and best development practices.",
    btnLabel: "Why Choose Us",
    to: "/about",
  },
];

function Home() {
  return (
    <main>
      <section
        className={styles.hero}
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/web.png)`,
        }}
      >
        <div className={styles.heroContent}>
          <h1>
            Building the Future with
            <br />
            Innovative IT &amp; Web
            <br />
            Solutions
          </h1>
          <p>
            Expert development, robust infrastructure, and
            <br />
            scalable applications.
          </p>
          <Link to="/about" className="btn btn-green btn-lg">
            Build With Mak
          </Link>
        </div>
      </section>

      <section className={styles.cardsSection}>
        <div className={styles.cardsInner}>
          {cards.map((card) => (
            <div key={card.title} className={styles.card}>
              <h3 className={styles.cardTitle}>{card.title}</h3>
              <div className={styles.cardBody}>
                <div className={styles.cardIcon}>{card.icon}</div>
                <p>{card.body}</p>
              </div>
              <Link to={card.to} className="btn btn-green">
                {card.btnLabel}
              </Link>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

export default Home;
